export const FEEDBACK_CATEGORIES = [
  "error",
  "issue",
  "ask",
  "improvement",
  "idea",
  "question",
] as const
export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number]

export const FEEDBACK_STATUSES = [
  "open",
  "in_progress",
  "addressed",
  "closed",
] as const
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number]

/**
 * Inline attachment shape — any file type, base64-encoded into the data URL.
 * Image MIME types render inline in the thread; everything else renders as a
 * download chip with the filename + size.
 */
export interface FeedbackAttachment {
  dataUrl: string
  name: string
  mime: string
  size: number
}

export interface Feedback {
  id: string
  companyId: string
  authorUserId: string
  title: string
  description: string
  category: FeedbackCategory
  status: FeedbackStatus
  pageUrl: string | null
  attachments: FeedbackAttachment[]
  syncId: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface FeedbackMessage {
  id: string
  companyId: string
  feedbackId: string
  authorUserId: string
  body: string
  isStaff: boolean
  attachments: FeedbackAttachment[]
  syncId: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}
